import NoTransactionsImage from 'src/shared/features/users/assets/empty/house.png'

import EmptyView from './empty-view'

const NoTransactions = () => {
  return (
    <EmptyView
      description="This user has not completed any transactions yet."
      image={<img src={NoTransactionsImage} className="translate-y-7 md:translate-y-5" />}
      title="No transactions yet"
    />
  )
}

export default NoTransactions
